import React from "react";
import "./Showcase.scss";
import { H3 } from "../../ui/Typography";
import Pagination from "../../ui/pagination/Pagination";

function ShowcasePagination() {
  const [page, setPage] = React.useState(1);
  return (
    <>
      <div className="showcase-wrapper">
        <H3>Pagination</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <th>12px font</th>
                <th>16px font</th>
              </tr>
              <tr>
                <td>
                  <div id="product-list" className="product-list">
                    {Array.from({ length: 20 }, (_, i) => (
                      <div className="item" key={i}>
                        Item {i + 1}
                      </div>
                    ))}
                  </div>

                  <Pagination
                    targetId="product-list"
                    itemsPerPage={5}
                    size="sm"
                  />
                </td>
                <td>
                  <div id="product-list-md" className="product-list">
                    {Array.from({ length: 20 }, (_, i) => (
                      <div className="item" key={i}>
                        Item {i + 1}
                      </div>
                    ))}
                  </div>

                  <Pagination
                    targetId="product-list-md"
                    itemsPerPage={5}
                    size="md"
                  />
                </td>
              </tr>
              <tr>
                <th>20px font</th>
                <th>24px font</th>
              </tr>
              <tr>
                <td>
                  <div id="product-list-lg" className="product-list">
                    {Array.from({ length: 20 }, (_, i) => (
                      <div className="item" key={i}>
                        Item {i + 1}
                      </div>
                    ))}
                  </div>

                  <Pagination
                    targetId="product-list-lg"
                    itemsPerPage={5}
                    size="lg"
                  />
                </td>
                <td>
                  <div id="product-list-xl" className="product-list">
                    {Array.from({ length: 20 }, (_, i) => (
                      <div className="item" key={i}>
                        Item {i + 1}
                      </div>
                    ))}
                  </div>

                  <Pagination
                    targetId="product-list-xl"
                    itemsPerPage={5}
                    size="xl"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ShowcasePagination;
